module.exports = __webpack_public_path__ + "assets/ic_badge_08.f1990028.svg";